import { makeAutoObservable } from 'mobx'
import { emailLink } from '@/shared/config/site'
import type { LandingLeadFormValues } from './landing-lead-form.schema'
import type { LandingPageModel } from './landing-page.model'

export class LandingLeadModel {
  public readonly page: LandingPageModel
  public readonly values: LandingLeadFormValues

  public constructor(page: LandingPageModel, values: LandingLeadFormValues) {
    this.page = page
    this.values = values

    makeAutoObservable(this, {}, { autoBind: true })
  }

  public get emailDomain(): string {
    return this.values.email.split('@')[1]?.toLowerCase() ?? ''
  }

  public get mailtoHref(): string {
    const formCopy = {
      companyLabel: 'Company or project',
      companyPlaceholder: 'Optional, but useful',
      emailBodyCompany: 'Company or project',
      emailBodyEmail: 'Email',
      emailBodyName: 'Name',
      emailBodyNotProvided: 'Not provided',
      emailBodySource: 'Source',
      emailBodySourceSuffix: 'page',
      emailLabel: 'Email',
      emailPlaceholder: 'you@company.com',
      mailSubjectPrefix: 'Lead',
      messageLabel: 'What needs to happen?',
      messagePlaceholder: 'Short version: what exists, what is broken, and what you want from me.',
      nameLabel: 'Name',
      namePlaceholder: 'Your name',
      privacyNote: 'This opens a direct email draft. No newsletter trap.',
      submitLabel: 'Open email draft',
      submittedBody: 'Send it from your email client so it actually reaches the inbox.',
      submittedTitle: 'Draft opened.',
      validationMessage: 'Fix the marked fields and try again.',
    }
    const subject = `${formCopy.mailSubjectPrefix}: ${this.page.content.navLabel}`
    const body = [
      `${formCopy.emailBodyName}: ${this.values.name}`,
      `${formCopy.emailBodyEmail}: ${this.values.email}`,
      `${formCopy.emailBodyCompany}: ${this.values.company || formCopy.emailBodyNotProvided}`,
      `${formCopy.emailBodySource}: ${this.page.content.navLabel} ${formCopy.emailBodySourceSuffix}`,
      '',
      this.values.message,
    ].join('\n')

    return `${emailLink.href}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
  }
}
